import { createSelector } from '@ngrx/store';

import { mentionableUsersFeature } from './mentionable-users.feature';

const { selectMentionableUsersState } = mentionableUsersFeature;

export const selectMentionableUsers = createSelector(
  selectMentionableUsersState,
  ({ users }) => users,
);

export const selectMentionableUsersCachedAt = createSelector(
  selectMentionableUsersState,
  ({ cachedAt }) => cachedAt,
);
